import { useState, useMemo } from 'react';

import { Grid, Box } from '@material-ui/core';
import { SAIDIalogContainer } from '@setvi/shared/components';

import { EQUIPMENT_TYPE, EquipmentCardProps } from './components/card';
import { SearchFormOptions } from '../product-match/enums';
import { EquipmentCard, PizzaForm } from './components';

export interface Props {
  [key: string]: string;
}

export interface ProductMatchProps {
  title?: string;
  props?: Props;
  description?: string;
  handleSearch: (type: SearchFormOptions, value: string) => void;
  onClose?: () => void;
}

const contentWidth = '30vw';
const contentHeight = '70vh';

const defaultValues = {
  type: '',
  location: '',
  size: '',
  hours: '',
  requirements: '',
  comments: ''
};

const SEquipmentFinder = ({
  props,
  title = 'AI Product Finder',
  description = 'AI can help you find a product through a series of questions.',

  handleSearch,
  onClose
}: ProductMatchProps) => {
  const [values, setValues] = useState(props || defaultValues);
  const cards: EquipmentCardProps[] = [
    {
      title: 'Pizza Oven Finder',
      type: EQUIPMENT_TYPE.PIZZA,
      tag: 'Oven',
      onClick: (type: EQUIPMENT_TYPE) => {
        setValues({
          type,
          location: '',
          size: '',
          hours: '',
          requirements: '',
          comments: ''
        });
      }
    }
  ];

  const newTitle = useMemo(() => {
    if (values?.type)
      return `AI ${cards?.find(c => c.type === values.type)?.title}`;

    return title;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, values]);

  return (
    <SAIDIalogContainer
      width={contentWidth}
      height={contentHeight}
      title={newTitle}
      headerDivider={false}
      description={description}>
      <Box
        display="flex"
        alignContent="center"
        justifyContent="center"
        overflow="hidden"
        height="100%"
        style={{
          margin: '0 20px'
        }}>
        {!values?.type ? (
          <Grid container spacing={1}>
            {cards.map(({ title: t, type, tag, onClick }) => (
              <Grid item xs={12} md="auto" key={type}>
                <EquipmentCard
                  title={t}
                  type={type}
                  tag={tag}
                  onClick={onClick}
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <PizzaForm
            values={values}
            onChange={(newValue: { [key: string]: string }) => {
              setValues(newValue);
            }}
            onSubmit={(c: { [key: string]: string }) => {
              const search = `Looking for a new pizza oven for a ${c?.location} that can cook a maximum pizza size of ${c?.size} inches, we will be making max ${c?.hours} pizzas an hour and we have a ${c.requirements} outlet. ${c?.comments?.trim() ? `${c?.comments}.` : ''} Can you recommend something?`;
              handleSearch(SearchFormOptions.text, search);
              onClose?.();
            }}
          />
        )}
      </Box>
    </SAIDIalogContainer>
  );
};

export default SEquipmentFinder;
